// API base — DO App Platform "infill-patient-case-api-test".
// Frontend base — DO Spaces CDN endpoint serving the admin SPA.
const apiBase = "https://infill-patient-case-api-test-s3xtq.ondigitalocean.app/api/v1";
const frontendBase = "https://test.case.science-voyager.com";

export const environment = {
    production: true,
    logErrorInConsole: true,
    environmentName: "test",
    version: require("../../package.json").version,
    httpRequestTimeoutSeconds: 120,
    utcDateFormat: "yyyy-MM-dd HH:mm:ss",
    frontedAppUrl: `${frontendBase}/`,
    oauthBaseAPI: `${apiBase}/auth/`,
    usersAPI: `${apiBase}/users/`,
    rolesAPI: `${apiBase}/roles/`,
    organizationsAPI: `${apiBase}/organizations/`,
    profileAPI: `${apiBase}/profile/`,
    resetPasswordAPI: `${apiBase}/resetpassword/`,
    languagesAPI: `${apiBase}/languages/`,
    smtpMailAccountsAPI: `${apiBase}/mailaccounts/`,
    mailtemplatesAPI: `${apiBase}/mailtemplates/`,
    systemLogMessagesAPI: `${apiBase}/systemlogs/`,
    systemJobPerformancesAPI: `${apiBase}/systemjobs/`,
    systemErrorsAPI: `${apiBase}/systemerrors/`,
    patientCasesAPI: `${apiBase}/patientcases/`
};
